.dialog-content-layout {
  @apply flex flex-col;

  & > * {
    @apply flex-none;
  }

  @screen mmd {
    @apply grid;
    grid-template:
      ' media info   ' 1fr
      ' media footer ' auto
      / 1fr 500px;
  }
}
